import React from "react";

const KpiCard = ({ icon: Icon, iconBg, iconColor, value, label, sub }) => (
  <div className="bg-white rounded-2xl border border-surface-border p-5 flex flex-col gap-3">
    <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${iconBg}`}>
      <Icon className={`w-5 h-5 ${iconColor}`} />
    </div>
    <div>
      <p className="text-3xl font-extrabold text-brand-text">
        {value !== undefined && value !== null && value !== '' ? value : '—'}
      </p>
      <p className="text-sm font-semibold text-brand-text mt-0.5">{label}</p>
      <p className="text-xs text-brand-muted mt-0.5">{sub}</p>
    </div>
  </div>
);

export default KpiCard;
